export default {
  education: {
    webinar: {
      title: "سجل في الحدث للوصول إلى التسجيل",
      text: "يمكنك تسجيل الدخول تلقائيا باستخدام بيانات حسابك الحالي أو إدخال البيانات يدويا في الخطوة التالية.",
      label: "من خلال التسجيل ، أنت تقبل",
      link: "شروط التحويل إلى شريك خدمة متس لينك",
      close: "أدخل البيانات يدويا",
      submit: "التسجيل",
    },
    metaTitle: "التعليم",
    noContentLang: "لا توجد مواد منشورة بهذه اللغة حتى الآن.",
    titles: {
      material: "تدريب للأطباء",
      course: "دورات تعليمية للأطباء",
      simulator: "محاكيات للأطباء",
      webinar: "ندوات عبر الإنترنت للأطباء",
    },
    filters: {
      selects: {
        type: {
          placeholder: "نوع المواد",
        },
        lang: {
          placeholder: "اللغة",
        },
        status: {
          placeholder: "الحالة",
          values: {
            actual: "الحالية",
            overpast: "المنتهية",
          },
        },
        specialty: {
          placeholder: "التخصص",
        },
      },
      tabs: {
        material: "كل المواد",
        course: "الدورات",
        simulator: "المحاكيات",
        webinar: "الندوات",
      },
    },
    content: {
      subtitles: {
        your: {
          material: "موادك",
          course: "دوراتك",
          simulator: "محاكياتك",
          webinar: "ندواتك",
        },
        recomended: {
          material: "المواد الموصى بها",
          course: "الدورات الموصى بها",
          simulator: "المحاكيات الموصى بها",
          webinar: "الندوات الموصى بها",
        },
      },
    },
  },
  Lessons: {
    Lesson: {
      title: "الدرس",
      Files: "المرفقات",
      DownloadAll: "تحميل الكل",
    },
    status: {
      success: "تم اجتيازه",
      unsuccess: "لم يتم اجتيازه",
      stop: "غير متاح",
    },
  },
  Tests: {
    table: {
      tests: "اختبارات",
      description: "وصف",
      points: "نقاط",
      status: "حالة",
    },
    modal: {
      title: "هل تريد إنهاء الاختبار؟",
    },
    questions: {
      question: "سؤال",
      answer: "إجابة",
      correct: "صحيح",
      incorrect: "غير صحيح",
      moderated: "قيد المراجعة",
      navigation: "تنقل بين الأسئلة",
      enterAnswer: "أدخل الإجابة...",
    },
    errors: {
      required: "سؤال مطلوب",
    },
    submit: "إنهاء الاختبار",
    result: "النتيجة",
    repeat: "إعادة الاختبار",
  },
  afterPayCourse: {
    title: "لقد اشتريت الدورة بنجاح",
    text: "الآن لديك حق الوصول إلى المواد التدريبية.",
    buttonText: "اذهب إلى الدورة",
  },
  coursePage: {
    courseType: {
      course: "الدورة",
      simulator: "المدرب",
      webinar: "الويبينار",
    },
    groupNumber: "{ن}تيار ال",
    manager: "مدير",
    curator: "المعلم",
    free: "مجاني",
  },
  coursesPage: {
    materials: "المواد",
    schools: "مدارس المؤلف",
    universities: "الجامعات",
    showPast: "عرض الأحداث الماضية",
    emptyList: "لا توجد مثل هذه المواد",
    show: "عرض",
    result1: "النتيجة",
    result2: "النتيجة",
    result5: "النتائج",
    filters: "الفلاتر",
    clear: "واضح",
  },
};
